function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { classNamesFor } from '../utils/classNames';
import findAndDecorateImageProps from '../utils/findAndDecorateImageProps';
import Icon from '../Icon';
import MediaFrame from '../MediaFrame';
var cx;
/**
 * The ChatGroup component represents a chat group in it's simplest
 * form. It often is used within a list of other ChatGroup components.
 *
 *
 * ## Composed of
 * - [AvatarIcon](../AvatarIcon/README.md)
 *
 * ## Related Components
 * - [Player](../Player/README.md)
 * - [Trophy](../Trophy/README.md)
 *
 * ## Usage
 *
 * ```jsx
 * <ChatGroup
 *   name="my awesome group"
 *   image={(<Media src="https://images.com/my-group.webp" alt="group icon" />)}
 *   latestMessage="We gamin?"
 *   latestMessageSenderName="Sarah P"
 *   latestMessageTimestamp="2019-10-30T01:05:48.329Z"
 * />
 * ```
 *
 * ## Props
 */

var ChatGroup = /*#__PURE__*/function (_PureComponent) {
  _inherits(ChatGroup, _PureComponent);

  var _super = _createSuper(ChatGroup);

  function ChatGroup() {
    _classCallCheck(this, ChatGroup);

    return _super.apply(this, arguments);
  }

  _createClass(ChatGroup, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          qa = _this$props.qa,
          className = _this$props.className,
          name = _this$props.name,
          image = _this$props.image,
          latestMessage = _this$props.latestMessage,
          latestMessageSenderName = _this$props.latestMessageSenderName,
          latestMessageTimestamp = _this$props.latestMessageTimestamp;

      var _ChatGroup$getClassNa = ChatGroup.getClassName({
        className: className
      }),
          root = _ChatGroup$getClassNa.root,
          imageClass = _ChatGroup$getClassNa.image,
          fallbackIcon = _ChatGroup$getClassNa.fallbackIcon,
          info = _ChatGroup$getClassNa.info,
          line1 = _ChatGroup$getClassNa.line1,
          primaryInfo = _ChatGroup$getClassNa.primaryInfo,
          secondaryInfo = _ChatGroup$getClassNa.secondaryInfo,
          tertiaryInfo = _ChatGroup$getClassNa.tertiaryInfo;

      var fallback = /*#__PURE__*/React.createElement(MediaFrame, {
        qa: "".concat(qa, "#fallbackImage"),
        className: fallbackIcon,
        aspectRatio: "1:1"
      }, /*#__PURE__*/React.createElement(Icon, {
        className: "psw-center",
        type: "messages"
      }));
      var decoratedImage = findAndDecorateImageProps(image, {
        qa: "".concat(qa, "#image"),
        width: '100%',
        className: 'psw-fill-x',
        children: fallback
      });
      return /*#__PURE__*/React.createElement("article", {
        "data-qa": qa,
        className: root
      }, /*#__PURE__*/React.createElement("div", {
        className: imageClass
      }, decoratedImage || fallback), /*#__PURE__*/React.createElement("div", {
        className: info
      }, /*#__PURE__*/React.createElement("div", {
        className: line1
      }, /*#__PURE__*/React.createElement("span", {
        "data-qa": "".concat(qa, "#name"),
        className: primaryInfo
      }, name), /*#__PURE__*/React.createElement("span", {
        "data-qa": "".concat(qa, "#timestamp"),
        className: secondaryInfo
      }, latestMessageTimestamp)), /*#__PURE__*/React.createElement("div", {
        "data-qa": "".concat(qa, "#message"),
        className: tertiaryInfo
      }, latestMessageSenderName && "".concat(latestMessageSenderName, ": "), latestMessage)));
    }
  }]);

  return ChatGroup;
}(PureComponent);

ChatGroup.getClassName = function (_ref) {
  var className = _ref.className;
  return {
    root: cx('psw-chat-group', 'psw-l-line-left', 'psw-l-anchor', className),
    image: cx('psw-chat-group-image', 'psw-l-anchor', 'psw-l-image-m', 'psw-round', 'psw-clip'),
    fallbackIcon: cx('psw-chat-group-image', 'psw-p-s', 'psw-bg-3', 'psw-round'),
    info: cx('psw-chat-group-info', 'psw-l-line-enable-truncation', 'psw-p-l-s', 'psw-fill-x'),
    line1: cx('psw-l-line-repel'),
    primaryInfo: cx('psw-truncate-text-1', 'psw-text-medium'),
    secondaryInfo: cx('psw-chat-group-timestamp', 'psw-body-2', 'psw-m-l-xs', 'psw-c-secondary', 'psw-l-line-no-wrap'),
    tertiaryInfo: cx('psw-truncate-text-1', 'psw-c-secondary')
  };
};

ChatGroup.useClassNames = function (classNames) {
  ChatGroup.classNames = classNames;
};

ChatGroup.defaultProps = {
  qa: '',
  className: '',
  name: '',
  image: null,
  latestMessage: '',
  latestMessageSenderName: '',
  latestMessageTimestamp: ''
};
ChatGroup.propTypes = {
  /**
   * QA selector attribute used to target important elements for test validation
   */
  qa: PropTypes.string,

  /**
   * Allows adding a custom class or series of classes on the component
   * useful for setting margin or padding
   */
  className: PropTypes.string,

  /**
   * The name of the specific chat group
   */
  name: PropTypes.string,

  /**
   * The group image passed as a react node, likely an instance of Media or Image
   */
  image: PropTypes.node,

  /**
   * The most recently sent message in the group (if exists)
   */
  latestMessage: PropTypes.string,

  /**
   * The sender of the last message in the group (if exists)
   */
  latestMessageSenderName: PropTypes.string,

  /**
   * When the last message was sent (if exists)
   */
  latestMessageTimestamp: PropTypes.string
};
cx = classNamesFor(ChatGroup);
export default ChatGroup;